/* Content remains available as anchor-linked sections if JavaScript is unavailable. */
(() => {
  if (customElements.get('hs-kit-details')) return;
  customElements.define('hs-kit-details', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const tabs = Array.from(this.querySelectorAll('[data-kit-tab]'));
      const panels = Array.from(this.querySelectorAll('[data-kit-panel]'));
      if (!tabs.length || tabs.length !== panels.length) return;
      this.initialized = true;
      this.querySelector('.hs-kit-flavors').setAttribute('role', 'tablist');
      const select = (index, focus = false) => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        if (focus) {
          tabs[index].focus({ preventScroll: true });
          const nav = tabs[index].parentElement;
          const rect = tabs[index].getBoundingClientRect();
          const bounds = nav.getBoundingClientRect();
          if (rect.left < bounds.left) nav.scrollLeft -= bounds.left - rect.left + 4;
          if (rect.right > bounds.right) nav.scrollLeft += rect.right - bounds.right + 4;
        }
      };
      tabs.forEach((tab, i) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panels[i].id);
        panels[i].setAttribute('role', 'tabpanel');
        panels[i].tabIndex = 0;
        tab.addEventListener('click', event => { event.preventDefault(); select(i, true); });
        tab.addEventListener('keydown', event => {
          let target;
          if (event.key === 'ArrowRight') target = (i + 1) % tabs.length;
          if (event.key === 'ArrowLeft') target = (i - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = tabs.length - 1;
          if (target !== undefined) { event.preventDefault(); select(target, true); }
        });
      });
      const initial = panels.findIndex(panel => '#' + panel.id === location.hash);
      select(initial < 0 ? 0 : initial);
    }
  });
})();
